module.exports = __webpack_public_path__ + "assets/img/gaode.36a31c3c.png";